import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InfluencerHeader from "./InfluencerHeader";
import Navbar from "./Navbar";

const WalmartSearch = () => {
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        "https://server-side-influencer.onrender.com/influencer/walmartsearch",
        { searchTerm: search },
        { headers: { "Content-Type": "application/json" } }
      );
      const productList = res.data?.results || [];
      setProducts(productList.slice(0, 12));
    } catch (err) {
      console.error("Failed to fetch products", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [search]);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 760);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex h-screen hide-scrollbar" style={{ marginLeft: isSmallScreen ? "0px" : "72px" }}>
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <InfluencerHeader page="Walmart Search" />
      </div>

      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      <div className="flex-1 p-6 mt-12" style={{ marginLeft: isSmallScreen ? "0px" : "3px" }}>
        <div className="flex justify-center items-center gap-2 mb-6">
          <h2 className="text-xl font-extrabold text-gray-800 text-center mt-5 mb-4">
            Search Walmart Products
          </h2>
        </div>

        <div className="flex justify-center mb-6">
          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full max-w-md px-5 py-3 border border-gray-300 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(loading ? Array.from({ length: 6 }) : products).map((product, index) => (
            <div
              key={index}
              className="relative max-w-[600px] h-[380px] bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300"
            >
              <div className="h-1/2 bg-gray-200">
                {loading ? (
                  <Skeleton height="100%" />
                ) : (
                  <img
                    src={product?.image}
                    alt="Product"
                    className="w-full h-full object-contain lg:w-[30%] lg:mx-auto"
                  />
                )}
              </div>

              <div className="p-4 pt-6 flex flex-col gap-2 h-1/2">
                <h3 className="text-lg font-bold text-gray-800 mt-4 text-center">
                  {loading ? (
                    <Skeleton width={120} />
                  ) : (
                    product?.name?.slice(0, 60) + "..."
                  )}
                </h3>

                <div className="flex justify-center items-center text-sm text-gray-600">
                  {loading ? (
                    <Skeleton width={80} />
                  ) : (
                    <span className="text-lg font-semibold">
                      {product?.price || "Price not available"}
                    </span>
                  )}
                </div>

                {!loading && (
                  <div className="flex justify-center mt-4">
                    <a
                      href={product?.canonicalUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="text-sm bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition"
                    >
                      View Product
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WalmartSearch;
